import { GetInterfaceConfigInput } from "@zapier/bff";
import { RouterOutputs, trpc } from "../trpc";

interface UseInterfaceConfigOptions {
  enabled?: boolean;
}

export type InterfaceConfig = RouterOutputs["interface"]["getConfig"];

export function useInterfaceConfig(
  input: GetInterfaceConfigInput,
  options?: UseInterfaceConfigOptions,
) {
  const { data, isLoading, isFetching } = trpc.interface.getConfig.useQuery(
    input,
    { enabled: Boolean(input.id) && options?.enabled !== false },
  );

  return {
    config: data,
    isLoading,
    isFetching,
  };
}
